module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booking-summary__packages booking-summary-callout booking-summary-callout--info"
  }, [_c('strong', {
    staticClass: "callout-title"
  }, [_c('svg', {
    attrs: {
      "width": "25",
      "height": "30",
      "viewBox": "0 0 1792 1792"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1699 186q0 35-43 78l-632 632v768h320q26 0 45 19t19 45-19 45-45 19h-896q-26 0-45-19t-19-45 19-45 45-19h320v-768l-632-632q-43-43-43-78 0-23 18-36.5t38-17.5 43-4h1408q23 0 43 4t38 17.5 18 36.5z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Interested in a package?")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pack),
      expression: "pack"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pack = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChange]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("No thanks")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("-----------------")]), _vm._v(" "), _vm._l((_vm.packages), function(pack) {
    return _c('option', {
      key: pack.id,
      domProps: {
        "value": pack
      }
    }, [_vm._v("\n        " + _vm._s(pack.label) + "\n    ")])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adb04aee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/packageInput.vue
// module id = 614
// module chunks = 0